<template>
  <div>
    <el-table
      v-loading="loading"
      :data="data"
      size="medium"
      border
      stripe
    >
      <el-table-column
        label="STT"
        width="80"
        fixed="left"
        align="center"
      >
        <template slot-scope="scope">
          <span>
            {{ scope.row.stt }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="field in fields"
        :key="field.key"
        :prop="field.key"
        :label="field.label"
        :width="field.width"
      >
        <template slot-scope="scope">
          <span v-if="field.key === 'executing_at'">
            {{ scope.row.extra[field.key] | convertDateTime("HH:mm DD/MM/YYYY") }}
          </span>
          <span v-else-if="field.key === 'contract_id'">
            {{ scope.row.extra.contract_id | contractName(allContracts) }}
          </span>
          <span v-else-if="field.key === 'action_id'">
            {{ scope.row.extra.action_id | actionName(allContractActions) }}
          </span>
          <span v-else-if="field.key === 'document_id'">
            {{ scope.row.extra.document_id | documentName(documentData) }}
          </span>
          <span v-else-if="field.key === 'account_id'">
            {{ scope.row.extra.executing_user_id | accountName(accounts) }}
          </span>
          <span v-else>
            {{ scope.row.extra[field.key] }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        label="Nội dung chi tiết"
        width="200"
        fixed="right"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            icon="el-icon-document"
            type="primary"
            size="small"
            @click="() => $emit('detail', scope.row)"
          >
            Xem chi tiết
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import constants from "@/config/constants";

export default {
  name: "CardList",
  components: {},
  props: {
    data: Array,
    loading: Boolean,
    documentData: Array,
    accounts: Array,
  },
  data() {
    return {
      fileType: constants.FILE_TYPE,
    };
  },
  computed: {
    ...mapGetters("contract", ["allContracts", "allContractActions"]),
    fields() {
      return [
        {
          key: "contract_id",
          label: "Quy trình",
        },
        {
          key: "action_id",
          label: "Hành động",
        },
        {
          key: "document_id",
          label: "Tệp dữ liệu",
        },
        {
          key: "notes",
          label: "Chi chú",
        },
        {
          key: "executing_at",
          label: "Thời gian",
        },
        {
          key: "account_id",
          label: "Người thực hiện",
        },
      ];
    },
  },
  methods: {
    //
  },
};
</script>

<style lang="scss"></style>
